module.exports = __webpack_public_path__ + "img/asset-received.42fee365.svg";